export { default } from './PaymentInfo';
